<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active text-uppercase" aria-current="page">
                                {{ (originalCode) ? originalCode : 'Edit' }}
                            </li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

                    <!-- Loading -->
                    <div v-if="pgLoading" class="row h-100">
                        <div class="col-12 text-center">
                            <div class="spinner-grow mt-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <!-- End Loading -->

                    <form v-if="!pgLoading" @submit.prevent="editRow" class="h-100">

                        <!-- Usage stats (read-only) -->
                        <div class="card mt-5">
                            <div class="card-body py-3">
                                <div class="row text-center f13">
                                    <div class="col-md-3 col-6 mb-2">
                                        <div class="text-muted">Used</div>
                                        <div class="h4 mb-0">{{ stats.used_count }}</div>
                                    </div>
                                    <div class="col-md-3 col-6 mb-2">
                                        <div class="text-muted">Remaining Uses</div>
                                        <div class="h4 mb-0">
                                            <span v-if="stats.remaining_uses === null">&infin;</span>
                                            <span v-if="stats.remaining_uses !== null"
                                                :class="(stats.remaining_uses <= 0) ? 'text-danger' : ''">
                                                {{ stats.remaining_uses }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6 mb-2">
                                        <div class="text-muted">State</div>
                                        <div class="mt-1">
                                            <span v-if="stats.trash"
                                                class="badge badge-md badge-pill badge-dark-soft">Trash</span>
                                            <span v-if="!stats.trash && row.status"
                                                class="badge badge-md badge-pill badge-success">Active</span>
                                            <span v-if="!stats.trash && !row.status"
                                                class="badge badge-md badge-pill badge-secondary">Inactive</span>
                                            <span v-if="stats.is_expired"
                                                class="badge badge-md badge-pill badge-danger-soft ml-1">Expired</span>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6 mb-2">
                                        <div class="text-muted">Created By</div>
                                        <div class="mt-1">
                                            <span v-if="stats.user">{{ stats.user.name }}</span>
                                            <span v-if="!stats.user"> - </span>
                                            <div class="f12 text-muted">{{ stats.dateForHumans }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="stats.used_count > 0" class="alert alert-info f13 mb-0 mt-2">
                                    <span class="ti-info-alt mr-1"></span>
                                    This coupon has already been redeemed {{ stats.used_count }}
                                    {{ (stats.used_count == 1) ? 'time' : 'times' }}. Existing bookings keep their discount
                                    no matter what you change here.
                                </div>
                            </div>
                        </div>
                        <!-- End Usage stats -->

                        <!-- Content -->
                        <div class="tab-content">

                            <CouponForm
                                ref="form"
                                :row="row"
                                :errors="errors"
                                :tenant-id="tenant_id"
                                :existing-codes="existingCodes"
                                :original-code="originalCode">
                            </CouponForm>

                        </div>
                        <!-- End Content -->

                        <div class="col-md-12 row">
                            <div class="form-group mr-2">
                                <button class="btn btn-primary" :disabled="btnLoading">
                                    <span v-if="btnLoading">
                                        <span class="spinner-grow spinner-grow-sm mr-1"
                                            role="status" aria-hidden="true">
                                        </span>Loading...
                                    </span>
                                    <span v-if="!btnLoading" class="ti-check-box"></span>
                                    <span v-if="!btnLoading"> Update Coupon</span>
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-danger"
                                    :disabled="btnLoading"
                                    @click="cancel">
                                    <span class="ti-close"></span>
                                    <span> Cancel </span>
                                </button>
                            </div>
                        </div>

                    </form>
                </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->

    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import CouponForm from './Form.vue';
    import iziToast from 'izitoast';

    export default {
        name: 'Edit',
        components: {
            Header,
            Navigation,
            Footer,
            CouponForm
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    code: '',
                    name: '',
                    discount_type: 'percentage',
                    discount_value: '',
                    valid_from: '',
                    valid_to: '',
                    min_booking_value: '',
                    usage_limit: '',
                    packagesValues: [],
                    status: 1,
                },
                stats: {
                    used_count: 0,
                    remaining_uses: null,
                    is_expired: false,
                    trash: false,
                    user: null,
                    dateForHumans: '',
                },
                originalCode: '',
                errors: {},
                existingCodes: [],

                pgLoading: true,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'coupons',
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchRow();
        },
        methods: {

            // fetch Row
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                        const data = (res.data && res.data.row) ? res.data.row : res.data;

                        // tenant
                        if(data.tenant_id) {
                            this.tenant_id = data.tenant_id;
                        }
                        if(data.tenant_name) {
                            this.tenant_name = data.tenant_name;
                        }

                        // row
                        this.originalCode = data.code || '';
                        this.row.code = data.code || '';
                        this.row.name = data.name || '';
                        this.row.discount_type = data.discount_type || 'percentage';
                        this.row.discount_value = (data.discount_value !== null && data.discount_value !== undefined)
                            ? Number(data.discount_value) : '';
                        this.row.valid_from = data.valid_from || '';
                        this.row.valid_to = data.valid_to || '';
                        this.row.min_booking_value = (data.min_booking_value !== null && data.min_booking_value !== undefined)
                            ? data.min_booking_value : '';
                        this.row.usage_limit = (data.usage_limit !== null && data.usage_limit !== undefined)
                            ? data.usage_limit : '';
                        this.row.status = data.status ? 1 : 0;

                        // packages: prefer the {id, slug, title} objects, fall back to raw ids
                        if(Array.isArray(data.packages) && data.packages.length) {
                            this.row.packagesValues = data.packages.map(p => ({ id: p.id, title: p.title, slug: p.slug }));
                        } else if(Array.isArray(data.package_ids) && data.package_ids.length) {
                            this.row.packagesValues = data.package_ids.map(id => ({ id: id, title: 'Package #'+id }));
                        } else {
                            this.row.packagesValues = [];
                        }

                        // read-only stats
                        this.stats.used_count = data.used_count || 0;
                        this.stats.remaining_uses = (data.remaining_uses === undefined) ? null : data.remaining_uses;
                        this.stats.is_expired = !!data.is_expired;
                        this.stats.trash = !!data.trash;
                        this.stats.user = data.user || null;
                        this.stats.dateForHumans = data.dateForHumans || '';

                        this.pgLoading = false;
                        this.fetchExistingCodes(); // call next func
                    })
                    .catch(err => {
                        this.pgLoading = false;
                        if(err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        } else if(err.response && err.response.status == 403) {
                            this.$router.push({ name: 'forbidden' });
                        } else if(err.response && err.response.status == 404) {
                            this.$router.push({ name: 'not-found' });
                        } else {
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: (err.response && err.response.data) ? err.response.data.message : ''+err
                            });
                        }
                    })
                    .finally(() => {});
            },

            // existing codes for the "already exists" hint
            fetchExistingCodes(){
                if(this.tenant_id == 0) { return; }
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs,
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 1,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.existingCodes = res.data.coupons || [];
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // edit Row
            editRow(){
                this.errors = {};

                if(this.tenant_id == 0) {
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenant selected.'
                    });
                    return;
                }

                if(!this.$refs.form.validate()) {
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'Please fix the highlighted fields.'
                    });
                    return;
                }

                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'PUT',
                    data: this.$refs.form.buildPayload(),
                }
                this.axios(options)
                    .then(res => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: (res.data && res.data.message) ? res.data.message : 'Coupon updated successfully.',
                        });
                        this.$router.push({ name: this.refs });
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        // 401 / 403
                        if(err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        } else if(err.response && err.response.status == 403) {
                            this.$router.push({ name: 'forbidden' });
                        } else if(err.response && err.response.status == 422) {
                            this.errors = (err.response.data && err.response.data.errors) ? err.response.data.errors : {};
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: err.response.data.message || 'Validation failed.'
                            });
                        } else {
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: (err.response && err.response.data) ? err.response.data.message : ''+err
                            });
                        }
                    })
                    .finally(() => {})
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
